// dashboard — en. Part of the en i18n bundle; merged by ./index.js

export default {
  back: 'Back',
  createAccount: 'Create Account',
  creating: 'Creating Account...',
  companyNameLabel: 'Company / Business Name *',
  businessTypeLabel2: 'Business Type',
  locationLabel: 'Location (City)',
  websiteLabel: 'Website (optional)',
  businessLicenseLabel: 'Business License Number *',
  tinLabel: 'TIN Number',
  elmisLabel: 'E-LMIS Registration',
  passwordMismatch: 'Passwords do not match.',
  myDashboardTitle: 'My Dashboard',
  underReview: 'Account Under Review',
  underReviewMsg: "Our team is reviewing your business information. We'll contact you within 1–2 business days.",
  businessTab: '🏢 Business Info',
  socialTab: '📱 Social & Extra',
  passwordTab: '🔒 Password',
  saveChanges: 'Save Changes',
  saving: 'Saving...',
  profileUpdated: 'Profile updated successfully.',
  passwordChanged: 'Password changed successfully.',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  confirmPayment: 'Confirm Payment',
  rejectPayment: 'Reject Payment',
  requestDelivery: 'Request Delivery',
  removedByAdmin: 'Removed by Admin',
  myStoreTab: '🛍️ My Store',
  myOrdersTab: '📦 My Orders',
  myPurchasesTab: '🛒 My Purchases',
  productName: 'Product Name',
  productDescription: 'Description',
  productPrice: 'Price (ETB)',
  productCategory: 'Category',
  productStock: 'Stock Quantity',
  productNotFound: 'Product not found.',
  businessInformation: 'Business Information',
  yearEstablished: 'Year Established',
  numberOfEmployees: 'Number of Employees',
  socialMediaExtra: 'Social Media & Extra Details',
  instagramHandle: '📸 Instagram Handle',
  tiktokHandle: '🎵 TikTok Handle',
  telegramLabel: '✈️ Telegram',
  facebookPage: '📘 Facebook Page',
  servicesNeeded: 'Services Needed',
  servicesNeededPlaceholder: 'e.g. Social media management, content creation...',
  aboutYourBusiness: 'About Your Business',
  aboutYourBusinessPlaceholder: 'Tell us about your business...',
// Order labels,
  orderNumber: 'Order #',
  bank: 'Bank',
  proof: 'Proof',
  screenshot: 'Screenshot',
  ref: 'Ref',
// Marketplace — hardcoded text localized,
  dashPaymentTab: '💳 Payment',
  dashEmailInvalid: 'Please enter a valid email address.',
  dashPhoneInvalid: 'Phone number must be 9 digits.',
  dashUpdateFailed: 'We could not save your changes. Please try again.',
  dashPasswordChangeFailed: 'We could not change your password. Please try again.',
  dashFieldRequired: (f) => `${f} is required.`,
  dashPriceInvalid: (f) => `${f} must be greater than zero.`,
  dashStockInvalid: (f) => `${f} must be zero or greater.`,
  dashSaveProductFailed: 'We could not save the product. Please check every field and try again.',
  dashDeleteFailed: 'We could not delete that. Please try again.',
  dashDeletePhotoFailed: 'We could not delete the photo. Please try again.',
  dashConfirmFailed: 'We could not confirm the payment. Please try again.',
  dashRejectFailed: 'We could not reject the payment. Please try again.',
  dashBankAccountRequired: 'Enter the account number.',
  dashBankAdded: 'Payment method added successfully.',
  dashBankAddFailed: 'We could not add the payment method. Please try again.',
  dashSelectCategory: 'Select a category',
  dashSubcategory: 'Subcategory',
  dashSelectSubcategory: 'Select a subcategory',
  dashAvailableColors: 'Colours you have',
  dashColorsHint: 'Tap the circles to pick the colours you can deliver.',
  dashAllColors: 'Available in every colour',
  dashProductPhotos: 'Product photos',
  dashProductPhotosHint: 'Up to 5 photos. The first one becomes the cover.',
  dashUploadingPhotos: 'Uploading photos...',
  dashStockLabel: (n) => `In stock: ${n}`,
  dashPaymentMethods: 'Where you get paid',
  dashPaymentMethodsDesc: 'Add the bank account customers should send their payments to. They see these details at checkout.',
  dashAddBankAccount: 'Add a bank account',
  dashBankLabel: 'Bank',
  dashAccountNumber: 'Account number',
  dashAccountNumberPh: 'e.g. 1000123456789',
  dashAccountNameOptional: 'Account name (optional)',
  dashAccountNamePh: 'e.g. My Business PLC',
  dashAddPaymentMethod: 'Save account',
  dashYourAccounts: 'Your accounts',
  dashNoBankAccounts: 'No payment method added yet.',
  dashAccountLabel: (n) => `Account: ${n}`,
  dashStatusPending: 'In review',
  dashStatusActive: 'Verified',
  dashStatusSuspended: 'Suspended',
  dashOrderStatusPending: 'Waiting for payment',
  dashOrderStatusConfirmed: 'Confirmed',
  dashOrderStatusRejected: 'Rejected',
  dashStatusUnknown: (s) => s,
};

